import { render, staticRenderFns } from "./ExtraProductsDropdown.vue?vue&type=template&id=f5fad8bc"
import script from "./ExtraProductsDropdown.vue?vue&type=script&lang=js"
export * from "./ExtraProductsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports